var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "examList" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "testListBox",
      },
      [
        _vm._l(_vm.testList, function (item, index) {
          return _c(
            "div",
            { key: index, staticClass: "testList col col-sm-6 col-md-4" },
            [
              _c("div", [
                _c("div", { staticClass: "testInfoBox" }, [
                  _c("span", [_vm._v(_vm._s(item.testName))]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        item.test && item.test.referenceTimeType
                          ? item.test.referenceTimeType
                          : ""
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  item.status == "已开考" ||
                  (item.test &&
                    item.test.referenceTimeType &&
                    item.test.referenceTimeType == "固定时间考试")
                    ? _c("span", [_vm._v(_vm._s(`${item.testDateYTD} 开考`))])
                    : _vm._e(),
                  _vm._v(" "),
                  item.status == "待考" && item.test
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            `${item.test.startDate}开考 ${item.test.endDate}结束`
                          )
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  item.status == "已开考"
                    ? _c("span", [
                        _c("span", [_vm._v(_vm._s(item.startTime) + " 开始")]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(item.endTime) + " 结束")]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.type == "已完成"
                    ? _c("span", [
                        _vm._v(
                          "得分：" +
                            _vm._s(item.totalScore ? item.totalScore : 0)
                        ),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ItemFooter" },
                  [
                    _vm.type == "待考"
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary", round: "" },
                            on: {
                              click: function ($event) {
                                return _vm.getCurrentDate(item)
                              },
                            },
                          },
                          [_vm._v("前往考试")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type == "已完成"
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary", round: "" },
                            on: {
                              click: function ($event) {
                                return _vm.$router.push({
                                  name: "testPaper",
                                  query: { id: item.id },
                                })
                              },
                            },
                          },
                          [_vm._v("查看试卷")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]
          )
        }),
        _vm._v(" "),
        _vm.testList.length == 0
          ? _c("span", { staticClass: "default" }, [
              _c("img", {
                attrs: { src: require("@/assets/icon/notdata.png"), alt: "" },
              }),
              _vm._v("\n            暂时没有考试\n        "),
            ])
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/examList.vue?vue&type=template&id=1154ea26&scoped=true&
// module id = null
// module chunks = 